// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { IStoreState } from "interfaces/storeState";
import { createRequestErrorSelector, createRequestFetchingSelector } from "store/requests/selectors";

import { BillingRequestFetchingSelectorsNames } from "./actions";
import { IBilling } from "./interfaces";
import { IBillingState } from "./reducer";

export interface IWithBillingEntitiesState {
  entities: {
    billing: IBillingState;
  };
}

export const getIsFetchingBilling = (state: IStoreState): boolean =>
  createRequestFetchingSelector([BillingRequestFetchingSelectorsNames.FETCH_BILLING_INFO_REQUEST])(state);

export const getFetchingBillingError = (state: IStoreState): string =>
  createRequestErrorSelector([BillingRequestFetchingSelectorsNames.FETCH_BILLING_INFO_REQUEST])(state);

export const getIsUpdatingBillingInfo = (state: IStoreState): boolean =>
  createRequestFetchingSelector([BillingRequestFetchingSelectorsNames.UPDATE_BILLING_INFO_REQUEST])(state);

export const getBilling = (state: IWithBillingEntitiesState): IBilling | null => state.entities.billing;

export const selectHasCreditCard = (state: IWithBillingEntitiesState): boolean => !!state.entities.billing?.billingInfo;
